"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSocialIconSlots = exports.default = exports.SocialIcon = void 0;
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _utils = require("../utils");
var _iconsMapping = require("./iconsMapping");
var _socialIconClasses = require("./socialIconClasses");
var _jsxRuntime = require("react/jsx-runtime");
const getSocialIconSlots = ownerState => {
  const {
    size,
    kind
  } = ownerState;
  return {
    root: ['root', `size${(0, _utils.capitalize)(size)}`, `kind${(0, _utils.capitalize)(kind)}`],
    icon: ['icon']
  };
};
exports.getSocialIconSlots = getSocialIconSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getSocialIconSlots(ownerState);
  const composedClasses = (0, _base.unstable_composeClasses)(slots, _socialIconClasses.getSocialIconUtilityClass, classes);
  return composedClasses;
};
const SocialIconRoot = (0, _material.styled)('span', {
  name: 'MuiOriSocialIcon',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, styles[`size${(0, _utils.capitalize)(ownerState.size)}`], styles[`kind${(0, _utils.capitalize)(ownerState.kind)}`]]
})(({
  theme,
  ownerState
}) => ({
  display: 'inline-block',
  position: 'relative',
  boxSizing: 'border-box',
  overflow: 'hidden',
  borderRadius: '50%',
  margin: theme.spacing(1),
  padding: 0,
  textAlign: 'center',
  verticalAlign: 'middle',
  cursor: 'pointer',
  textDecoration: 'none',
  fontWeight: 'normal',
  '&::after': {
    content: '" "',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0
  },
  '&:hover, &:focus': {
    color: theme.palette.common.white,
    fontWeight: 'normal'
  },
  '&:hover&::after, &:focus&::after': {
    opacity: 0.4
  },
  ...(ownerState.size === 'medium' && {
    width: '3.5rem',
    height: '3.5rem',
    fontSize: '3.3rem',
    lineHeight: '4.2rem'
  }),
  ...(ownerState.size === 'small' && {
    width: '3rem',
    height: '3rem',
    fontSize: '2.8rem',
    lineHeight: '3.6rem'
  }),
  ...(ownerState.kind === 'email' && {
    color: '#333',
    '&:hover, &:focus': {
      color: '#333',
      fontWeight: 'normal'
    }
  }),
  ...(ownerState.kind === 'messenger' && {
    borderRadius: '50% 50% 50% 20%',
    background: 'radial-gradient(#fff 0%, #fff 62%, transparent 63%)',
    '&:hover, &:focus': {
      fontWeight: 'normal'
    }
  }),
  ...(ownerState.kind === 'vkontakte' && {
    borderRadius: '25%',
    background: 'radial-gradient(#fff 0, #fff 65%, transparent 70%)'
  }),
  ...(ownerState.kind === 'wechat' && {
    borderRadius: '20%',
    fontSize: '4.4rem',
    ...(ownerState.size === 'small' && {
      fontSize: '3.7rem'
    })
  })
}));
const IconRoot = (0, _material.styled)(_material.SvgIcon, {
  name: 'MuiOriSocialIcon',
  slot: 'Icon',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.icon]
})(({
  ownerState
}) => ({
  ...(ownerState.size === 'medium' && {
    fontSize: '5.1rem',
    transform: 'translate(-0.8rem, -0.8rem)'
  }),
  ...(ownerState.size === 'small' && {
    fontSize: '4.4rem',
    transform: 'translate(-0.7rem, -0.7rem)'
  }),
  ...(ownerState.kind === 'messenger' && ownerState.size === 'small' && {
    fontSize: '4.36rem',
    transform: 'translate(-0.66rem, -0.68rem)'
  })
}));
const SocialIcon = exports.SocialIcon = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _material.useThemeProps)({
    props: inProps,
    name: 'MuiOriSocialIcon'
  });
  const {
    kind,
    className,
    size = 'medium',
    component = 'span',
    ...other
  } = props;
  const ownerState = {
    ...props,
    size,
    kind
  };
  const classes = useUtilityClasses(ownerState);
  const {
    icon
  } = _iconsMapping.iconsMapping[ownerState.kind];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SocialIconRoot, {
    ref: ref,
    ownerState: ownerState,
    className: (0, _clsx.default)(classes.root, className),
    as: component,
    "aria-label": component === _material.ButtonBase || component === 'button' ? ownerState.kind : undefined,
    tabIndex: component === 'button' ? 0 : undefined,
    title: component === _material.Link || component === 'a' ? ownerState.kind : undefined,
    ...other,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconRoot, {
      as: icon,
      ownerState: ownerState,
      fontSize: "inherit",
      className: classes.icon
    })
  });
});
var _default = exports.default = SocialIcon;
//# sourceMappingURL=SocialIcon.js.map